import { tenantApi } from '../config/api'
import { ListEnrollmentGroupOptionsApiArg, PageGroupOptionDto } from './cycles'

export const GROUP_OPTIONS_PAGE_SIZE = 50

export type GroupOptionsPagesArg = Omit<ListEnrollmentGroupOptionsApiArg, 'page' | 'size'>

export const nextGroupOptionsPage = (
  lastPage: PageGroupOptionDto,
  _allPages: PageGroupOptionDto[],
  lastPageParam: number,
): number | undefined => (lastPageParam < (lastPage.pages ?? 0) ? lastPageParam + 1 : undefined)

// The generated listEnrollmentGroupOptions reads one page; the picker scrolls through them all.
const groupOptionsApi = tenantApi.injectEndpoints({
  endpoints: (build) => ({
    listEnrollmentGroupOptionPages: build.infiniteQuery<PageGroupOptionDto, GroupOptionsPagesArg, number>({
      infiniteQueryOptions: {
        initialPageParam: 1,
        getNextPageParam: nextGroupOptionsPage,
      },
      query: ({ queryArg, pageParam }) => ({
        url: `/tenants/${queryArg.tenantId}/enrollment-groups/options`,
        params: {
          filter_type: queryArg.filterType,
          search: queryArg.search,
          page: pageParam,
          size: GROUP_OPTIONS_PAGE_SIZE,
        },
      }),
      providesTags: [{ type: 'Users', id: 'LIST' }],
    }),
  }),
})

export const { useListEnrollmentGroupOptionPagesInfiniteQuery } = groupOptionsApi
